import React from "react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const partners = [{
  name: "Apex Dynamics",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1564626/img/partner_apex_dynamics.png"
}, {
  name: "Velocity Gear",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1564626/img/partner_velocity_gear.png"
}, {
  name: "Stride Systems",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1564626/img/partner_stride_systems.png"
}, {
  name: "Endurance Labs",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1564626/img/partner_endurance_labs.png"
}, {
  name: "Momentum Sport",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1564626/img/partner_momentum_sport.png"
}, {
  name: "Pulse Performance",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1564626/img/partner_pulse_performance.png"
}];
export default function BrandPartners() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="brand-partners" ref={ref} className="dark bg-background text-foreground py-20 relative overflow-hidden">
      <div className="container mx-auto px-4">
        <div className={cn("grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-12 items-center justify-items-center transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          {partners.map((partner, i) => <Link key={partner.name} to="/performance-lab" className="group relative flex items-center justify-center w-full" data-index={i}>
              <img src={partner.logo} alt={`${partner.name} logo`} className="h-8 w-auto object-contain opacity-40 brightness-0 invert transition-all duration-300 group-hover:opacity-100 group-hover:brightness-100 group-hover:invert-0" />
            </Link>)}
        </div>
      </div>
    </section>;
}